<template>
  <v-card class="ps-card" flat>
    <div class="ps-card__head">
      <v-icon small>mdi-gift-outline</v-icon>
      Extras
      <span class="ps-card__hint">Rahmen &amp; Co: Preise je Land, Artikel-IDs &amp; Kosten je Fulfiller</span>
      <v-spacer />
      <v-btn @click="openDialog(null)" color="primary" depressed small rounded>
        <v-icon small left>mdi-plus</v-icon>Extra
      </v-btn>
    </div>
    <v-card-text>
      <v-data-table
        :loading="loadingExtras"
        :headers="headers"
        :items="extras"
        class="ps-table"
        :items-per-page="15"
      >
        <template v-slot:item.name="{ item }">
          <span class="ps-name">{{ item.name || "—" }}</span>
          <div class="ps-sub">
            {{ item.key }}
            <span v-if="(item.aliasProductIds || []).length">
              · Alias: {{ item.aliasProductIds.join(", ") }}
            </span>
          </div>
        </template>
        <template v-slot:item.variants="{ item }">
          <span
            v-for="sku in Object.keys(item.variants || {}).sort()"
            :key="sku"
            class="ps-chip"
          >{{ sku }}</span>
          <span v-if="!Object.keys(item.variants || {}).length" class="ps-muted">
            keine Varianten
          </span>
        </template>
        <template v-slot:item.fulfiller="{ item }">
          <span
            v-for="entry in fulfillerCoverage(item)"
            :key="entry.id"
            class="ps-chip"
            :class="entry.complete ? 'ps-chip--primary' : ''"
            :title="entry.complete
              ? 'Artikel-ID für alle Varianten gepflegt'
              : `Artikel-ID fehlt bei: ${entry.missing.join(', ')}`"
          >
            {{ entry.name }} {{ entry.complete ? "✓" : `${entry.configured}/${entry.total}` }}
          </span>
          <span v-if="!fulfillerCoverage(item).length" class="ps-muted">—</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small @click="() => openDialog(item)">mdi-pencil</v-icon>
        </template>
      </v-data-table>
    </v-card-text>

    <ExtraDialog
      v-if="showDialog"
      :show="showDialog"
      :extra="extraToEdit"
      :on-close="() => (showDialog = false)"
    />
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ExtraDialog from "@/components/Settings/Products/Extras/ExtraDialog";

export default {
  name: "ExtrasSettings",
  components: { ExtraDialog },
  data() {
    return {
      showDialog: false,
      extraToEdit: null,
      headers: [
        { text: "Extra", value: "name" },
        { text: "Varianten (SKU)", value: "variants", sortable: false },
        { text: "Fulfiller", value: "fulfiller", sortable: false },
        { text: "", value: "actions", sortable: false, align: "end" },
      ],
    };
  },
  computed: {
    ...mapGetters(["extras", "loadingExtras", "printShops"]),
  },
  mounted() {
    this.loadExtras();
    if (!this.printShops.length) this.loadPrintShops();
  },
  methods: {
    ...mapActions(["loadExtras", "loadPrintShops"]),
    /** Je (am Extra aktiviertem) Fulfiller: für wie viele Varianten ist die
     *  Artikel-ID gepflegt? */
    fulfillerCoverage(item) {
      const skus = new Set(Object.keys(item.variants || {}));
      for (const config of Object.values(item.fulfiller || {})) {
        for (const sku of Object.keys(config.variants || {})) skus.add(sku);
      }
      return Object.keys(item.fulfiller || {}).map((id) => {
        const missing = [...skus].filter(
          (sku) => !item.fulfiller[id]?.variants?.[sku]?.id
        );
        return {
          id,
          name: this.printShops.find((shop) => shop.key === id)?.name || id,
          configured: skus.size - missing.length,
          total: skus.size,
          complete: missing.length === 0 && skus.size > 0,
          missing,
        };
      });
    },
    openDialog(extra) {
      this.extraToEdit = extra;
      this.showDialog = true;
    },
  },
};
</script>

<style scoped></style>
